export default "__VITE_ASSET__CyLlveNC__"